import request from '@/utils/request'

export default {
  phoneCode () {
    return request({
      url: 'phone_code',
      method: 'get'
    })
  }
}
